module.exports = __webpack_public_path__ + "static/media/btslogo.4fe525d0.webp";